module.exports = __webpack_public_path__ + "assets/img/picture2.800ea348.png";